
(function () {
    'use strict';

    if (window.__CART_PERSONALISE_EDIT__) return;
    window.__CART_PERSONALISE_EDIT__ = true;

    var QUICK_SEL = '.quick_personalize_personalise-drawer';
    var ADV_SEL = '.advance-personalise';
    var POSITIONS = ['top', 'middle', 'bottom'];
    var BACKCARD_SEL = '.backcard_personalise-drawer';

    /* ══════════════════════════════════════════════════════════════
       SHARED HELPERS
       ══════════════════════════════════════════════════════════════ */

    function toArray(l) { return Array.prototype.slice.call(l || []); }
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

    function normKey(s) {
        return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function isUrl(v) { return typeof v === 'string' && /^(https?:)?\/\//i.test(v); }

    function filenameFromUrl(url) {
        if (!url) return '';
        return (String(url).split('/').pop() || '').split('?')[0];
    }

    function deriveLabel(key) {
        var cleaned = String(key).replace(/[-_]?engraving$/i, '');
        var words = cleaned.split(/[-_]/).filter(Boolean);
        if (!words.length) return key;
        return words.map(function (w) {
            return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
        }).join(' ');
    }
    function flattenProps(item) {
        var out = {};
        var src = item && item.properties;
        if (!src) return out;

        if (Array.isArray(src)) {
            src.forEach(function (p) {
                if (!p) return;
                var k = p.name || p.key;
                if (k) out[k] = p.value;
            });
            return out;
        }
        if (typeof src === 'object') return Object.assign({}, src);
        return out;
    }

    function indexProps(flat) {
        var out = {};
        Object.keys(flat).forEach(function (k) {
            if (k.charAt(0) === '_') return;
            out[normKey(k)] = flat[k];
        });
        return out;
    }

    var ENGRAVING_KEY = / - (line \d+|icon|image|font style|embellishment (icon|position))$/i;

    function isEngravingKey(key) {
        if (!key) return false;
        if (key.charAt(0) === '_') return false;
        if (/^font style$/i.test(key.trim())) return true;
        return ENGRAVING_KEY.test(key);
    }

    function collectPrefixes(props) {
        var seen = {};
        var order = [];
        Object.keys(props).forEach(function (k) {
            var m = /^(.*?) - (line \d+|icon|image|font style|embellishment (?:icon|position))$/.exec(k);
            if (!m) return;
            var p = m[1];
            if (!p || seen[p]) return;
            seen[p] = true;
            order.push(p);
        });
        return order;
    }
    function originalPrefixMap(flat) {
        var out = {};
        Object.keys(flat).forEach(function (k) {
            if (k.charAt(0) === '_') return;
            var m = /^(.*?)\s*-\s*(line \d+|icon|image|font style|embellishment (?:icon|position))$/i.exec(k);
            if (!m) return;
            var p = normKey(m[1]);
            if (p && !out[p]) out[p] = m[1];
        });
        return out;
    }

    /* Read one prefix's worth of values out of the indexed properties. */
    function readEntry(props, prefixes) {
        for (var i = 0; i < prefixes.length; i++) {
            var p = normKey(prefixes[i]);

            var image = props[p + ' - image'];
            var icon = props[p + ' - icon'];
            var font = props[p + ' - font style'];
            var embIcon = props[p + ' - embellishment icon'];
            var embPos = props[p + ' - embellishment position'];

            var lines = [];
            for (var n = 1; n <= 12; n++) {
                var v = props[p + ' - line ' + n];
                if (v === undefined) break;
                lines.push(v == null ? '' : String(v).trim());
            }

            if (!image && !icon && !lines.length && !embIcon) continue;

            var entry = {
                prefix: p,
                font: font || null,
                embIcon: embIcon || null,
                embPos: embPos || null
            };

            if (image) {
                entry.type = 'image';
                entry.imageData = image;
                entry.filename = filenameFromUrl(image) || String(image);
            } else if (icon) {
                entry.type = 'icon';
                entry.value = String(icon).trim();
            } else if (lines.length) {
                entry.type = 'text';
                entry.value = lines;
            } else {
                entry.type = 'text';
                entry.value = [];
            }
            return entry;
        }
        return null;
    }

    function isDataUrl(v) { return typeof v === 'string' && v.indexOf('data:') === 0; }

    function dataUrlToFile(dataUrl, filename) {
        try {
            var parts = String(dataUrl).split(',');
            var mime = (/data:([^;]+)/.exec(parts[0]) || [])[1] || 'image/png';
            var binary = atob(parts[1]);
            var bytes = new Uint8Array(binary.length);
            for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            return new File([bytes], filename || 'image.png', { type: mime });
        } catch (e) {
            console.warn('[cart-personalise-edit] could not rebuild file from data URL:', e);
            return null;
        }
    }

    function imagePayload(label, st, fileInput, imgEl) {
        var domFile = (fileInput && fileInput.files && fileInput.files[0]) || null;
        var domSrc = imgEl ? imgEl.getAttribute('src') : null;

        var file = (st && st.rawFile instanceof File) ? st.rawFile : domFile;
        var src = (st && st.imageData) || domSrc || '';
        var filename = (st && st.filename) || (file && file.name) || filenameFromUrl(src);

        if (!file && isDataUrl(src)) file = dataUrlToFile(src, filename);

        return {
            label: label + ' - Image',
            file: file instanceof File ? file : null,
            url: (!(file instanceof File) && isUrl(src)) ? src : null,
            filename: filename || ''
        };
    }

    function showDrawerError(drawer, msg) {
        var el = drawer.querySelector('.quick_personalize_personalized-error') ||
            drawer.querySelector('.personalized-error');
        if (!el) return;
        clearTimeout(el._hideTimer);
        el.classList.remove('hidden');
        el.classList.add('active');
        el.style.color = 'red';
        el.textContent = msg;
        el._hideTimer = setTimeout(function () {
            el.classList.remove('active');
            el.classList.add('hidden');
        }, 3500);
    }
    function refreshCartSectionLocal() {
        var host = document.getElementById('main-cart-items');
        var sectionId = host ? host.getAttribute('data-id') : null;
        if (!sectionId) { window.location.reload(); return Promise.resolve(); }

        return fetch('/?sections=' + encodeURIComponent(sectionId))
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var html = data[sectionId];
                if (!html) { window.location.reload(); return; }

                var doc = new DOMParser().parseFromString(html, 'text/html');

                /* Swap the smallest wrapper that exists in both documents. */
                var targets = ['.cart_items_custom', '#main-cart-items .js-contents', 'cart-items'];
                var swapped = false;

                for (var i = 0; i < targets.length; i++) {
                    var next = doc.querySelector(targets[i]);
                    var cur = document.querySelector(targets[i]);
                    if (next && cur) { cur.innerHTML = next.innerHTML; swapped = true; break; }
                }

                if (!swapped) { window.location.reload(); return; }
            })
            .then(function () { return fetch('/cart.js'); })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                document.querySelectorAll('#cart-count, .cart-count, .cart-count-bubble span[aria-hidden]')
                    .forEach(function (el) { el.textContent = cart.item_count; });
                if (typeof window._bybPrefillAllCartDrawers === 'function') {
                    window._bybPrefillAllCartDrawers();
                }
                return cart;
            })
            .catch(function (err) {
                console.error('[cart-personalise-edit] section refresh failed:', err);
                window.location.reload();
            });
    }

    function refreshCart() {
        if (typeof window.refreshCartSection === 'function') return window.refreshCartSection();
        return refreshCartSectionLocal();
    }

    function urlToFile(url, filename) {
        return fetch(url)
            .then(function (r) { return r.blob(); })
            .then(function (blob) {
                return new File(
                    [blob],
                    filename || filenameFromUrl(url) || 'image.png',
                    { type: blob.type || 'image/png' }
                );
            });
    }

    /* ══════════════════════════════════════════════════════════════
       DRAWER RESOLUTION
       ══════════════════════════════════════════════════════════════ */
    function resolveDrawers(lineKey) {
        if (!lineKey) return [];
        var key = String(lineKey).trim();

        var matches = toArray(document.querySelectorAll('[data-key], [data-item-key]')).filter(function (el) {
            return (el.getAttribute('data-key') || '').trim() === key ||
                (el.getAttribute('data-item-key') || '').trim() === key;
        });

        var out = [];
        matches.filter(function (el) { return el.matches(ADV_SEL); })
            .forEach(function (el) { out.push({ kind: 'advance', root: el }); });
        matches.filter(function (el) { return el.matches(QUICK_SEL); })
            .forEach(function (el) { out.push({ kind: 'quick', root: el }); });
        matches.filter(function (el) { return el.matches(BACKCARD_SEL); })
            .forEach(function (el) { out.push({ kind: 'backcard', root: el }); });

        return out;
    }

    /* Kept for callers that only want the preferred drawer. */
    function resolveDrawer(lineKey) {
        return resolveDrawers(lineKey)[0] || null;
    }

    function openDrawer(root) {
        toArray(document.querySelectorAll('.personalise-drawer.active')).forEach(function (d) {
            if (d === root) return;
            d.classList.remove('active');
            d.classList.add('hidden');
        });

        root.classList.remove('hidden');
        root.classList.add('active');
        document.body.classList.add('personalise-drawer-open');

        var pop = root.closest('.pop-up');
        if (pop) pop.classList.add('active');
    }

    function closeDrawer(root) {
        root.classList.remove('active');
        root.classList.add('hidden');
        document.body.classList.remove('personalise-drawer-open');
        var pop = root.closest('.pop-up');
        if (pop) pop.classList.remove('active');
    }

    /* ══════════════════════════════════════════════════════════════
       QUICK DRAWER
       ══════════════════════════════════════════════════════════════ */

    /* Sides come from this drawer's own markup, never from the global
       window.ENGRAVING_SIDES — on the cart page every drawer's inline script
       overwrites that global, so the last one rendered would win. */
    function quickSides(root) {
        var seen = {};
        var out = [];

        toArray(root.querySelectorAll('.quick_personalize_main-tab[data-side]')).forEach(function (tab) {
            var slug = tab.getAttribute('data-side');
            if (!slug || seen[slug]) return;
            seen[slug] = true;
            out.push({ slug: slug, label: (tab.textContent || slug).trim() });
        });

        toArray(root.querySelectorAll('.quick_personalize_tab-panel[data-side]')).forEach(function (panel) {
            var slug = panel.getAttribute('data-side');
            if (!slug || seen[slug]) return;
            seen[slug] = true;
            var lbl = root.querySelector('.quick_personalize_split-preview-col[data-side="' + slug + '"] .quick_personalize_split-preview-label');
            out.push({ slug: slug, label: lbl ? lbl.textContent.trim() : slug });
        });

        return out;
    }

    function quickIconLookup(root, side, iconName) {
        var items = toArray(root.querySelectorAll('.quick_personalize_icon-item[data-side="' + side + '"]'));
        for (var i = 0; i < items.length; i++) {
            if (normKey(items[i].getAttribute('data-icon-name')) === normKey(iconName)) return items[i];
        }
        return null;
    }

    function quickBuildState(root, props, origMap) {
        var sides = quickSides(root);
        var sharedFont = props['font style'] || null;
        var state = {};
        var filled = false;
        origMap = origMap || {};

        var available = collectPrefixes(props);
        var used = {};

        /* Pass 1: match each side on the prefix its slug derives.
           Pass 2: anything still unmatched takes the next unclaimed prefix
           off the line, in order. */
        var entries = {};

        sides.forEach(function (s) {
            var label = deriveLabel(s.slug);
            var tried = [label, s.slug];
            var entry = readEntry(props, tried);
            if (entry) {
                tried.forEach(function (t) { used[normKey(t)] = true; });
                entries[s.slug] = entry;
            }
        });

        sides.forEach(function (s) {
            if (entries[s.slug]) return;
            var spare = available.filter(function (p) { return !used[p]; })[0];
            if (!spare) return;
            var entry = readEntry(props, [spare]);
            if (!entry) return;
            used[spare] = true;
            entries[s.slug] = entry;
            console.warn('[cart-personalise-edit] side "' + s.slug +
                '" matched property prefix "' + spare +
                '" by position — the label appears to have changed since this line was added.');
        });

        if (!Object.keys(entries).length && available.length) {
            console.warn('[cart-personalise-edit] no side matched. Sides on this drawer: ' +
                sides.map(function (s) { return s.slug + ' → "' + deriveLabel(s.slug) + '"'; }).join(', ') +
                ' | prefixes on this cart line: ' + available.join(', '));
        }

        sides.forEach(function (s) {
            var entry = entries[s.slug];
            if (!entry) return;

            /* Remember the exact property name this side came in under, so
               Update writes back "engraving - Line 1" rather than inventing
               a new key. */
            var panel = root.querySelector('.quick_personalize_tab-panel[data-side="' + s.slug + '"]');
            if (panel) panel.setAttribute('data-prop-prefix', origMap[entry.prefix] || '');

            var out = {
                type: entry.type,
                value: null,
                font: null,
                fontName: null,
                imageData: null,
                filename: null,
                iconIndex: null,
                rawFile: null,
                embellishment: { checked: false, iconName: '', iconImg: '', position: '' }
            };

            if (entry.type === 'text') {
                var lines = (entry.value || []).filter(function (v) { return v !== '' && v != null; });
                if (!lines.length && !entry.embIcon) return;
                var font = entry.font || sharedFont || null;
                out.value = entry.value;
                out.fontName = font;
                out.font = font || 'inherit';

            } else if (entry.type === 'icon') {
                var el = quickIconLookup(root, s.slug, entry.value);
                out.value = el ? el.getAttribute('data-icon-name') : entry.value;
                out.iconIndex = el ? Number(el.getAttribute('data-icon-index')) : null;
                if (el) {
                    out.iconHTML = el.innerHTML;
                    var im = el.querySelector('img');
                    out.iconImage = im ? im.getAttribute('src') : '';
                }

            } else if (entry.type === 'image') {
                out.imageData = entry.imageData;
                out.filename = entry.filename;
                out.restoredFromUrl = isUrl(entry.imageData);
            }

            if (entry.embIcon) {
                var embEl = quickIconLookup(root, s.slug, entry.embIcon);
                var embImg = embEl ? embEl.querySelector('img') : null;
                out.embellishment = {
                    checked: true,
                    enabled: true,
                    iconName: entry.embIcon,
                    iconImg: embImg ? embImg.getAttribute('src') : '',
                    position: entry.embPos || ''
                };
            }

            state[s.slug] = out;
            filled = true;
        });

        return filled ? { sides: sides, state: state } : null;
    }

    function quickLoad(root, item) {
        var flat = flattenProps(item);
        var props = indexProps(flat);
        var origMap = originalPrefixMap(flat);
        var sides = quickSides(root);

        /* Clear first, unconditionally. window._personaliseState is shared by
           every quick drawer on the page, so if this line matches nothing and
           we skip the reset, handleEdit() will happily repopulate the inputs
           with the values from whichever line was edited before this one. */
        window.ENGRAVING_SIDES = sides;
        if (typeof window.resetDrawerState === 'function') {
            window.resetDrawerState(root);
            window.ENGRAVING_SIDES = sides;   // reset rebuilds from the global
        }

        var built = quickBuildState(root, props, origMap);
        if (!built) return false;

        window.ENGRAVING_SIDES = built.sides;

        if (typeof window.loadPersonaliseState !== 'function') return false;
        window.loadPersonaliseState(built.state, root);

        /* loadPersonaliseState flags restored images as needsReupload so a
           PDP add-to-cart cannot silently drop the file. On a cart edit the
           image already lives on the CDN and is re-sent as its URL, so the
           shopper must not be forced to upload it again. */
        built.sides.forEach(function (s) {
            var st = window._personaliseState[s.slug];
            if (!st) return;
            if (st.type === 'image' && st.imageData) {
                st.needsReupload = false;
                st.restoredFromUrl = isUrl(st.imageData);
            }
        });

        /* Terms were accepted when the line was first added. */
        toArray(root.querySelectorAll('.quick_personalize_terms-checkbox input[type="checkbox"]'))
            .forEach(function (cb) { cb.checked = true; });
        var allBox = root.querySelector('[data-id="terms-check--all"]');
        if (allBox) allBox.checked = true;

        var firstSide = built.sides.filter(function (s) {
            var st = window._personaliseState[s.slug];
            return st && st.type;
        })[0];

        if (firstSide && typeof window.showReview === 'function') {
            window.showReview(firstSide.slug);
        }

        return true;
    }

    function quickCollect(root) {
    var sides = quickSides(root);
    var state = window._personaliseState || {};
    var props = {};
    var images = [];
    var fontsByLabel = {};
    var fontAdded = false;

        sides.forEach(function (s) {
            var panel = root.querySelector('.quick_personalize_tab-panel[data-side="' + s.slug + '"]');
            var label = (panel && panel.getAttribute('data-prop-prefix')) || deriveLabel(s.slug);
            var st = state[s.slug];
            if (st && st.type === 'text' && st.fontName) {
                fontsByLabel[label] = st.fontName;
            }
        });

        var uniqueFonts = Object.keys(fontsByLabel)
            .map(function (k) { return fontsByLabel[k]; })
            .filter(function (v, i, a) { return a.indexOf(v) === i; });
        var fontMode = uniqueFonts.length === 1 ? 'unified' : (uniqueFonts.length > 1 ? 'perLabel' : 'none');

        sides.forEach(function (s) {
            var panel = root.querySelector('.quick_personalize_tab-panel[data-side="' + s.slug + '"]');
            var label = (panel && panel.getAttribute('data-prop-prefix')) || deriveLabel(s.slug);
            var st = state[s.slug];

            var imgEl = root.querySelector('[data-id="' + s.slug + '-img-preview"]');
            var fileInput = root.querySelector('.quick_personalize_upload-zone input[type="file"][data-side="' + s.slug + '"]');
            var domFile = (fileInput && fileInput.files && fileInput.files[0]) || null;
            var domSrc = imgEl && imgEl.getAttribute('src');
            var domHasImage = !!(domFile || (domSrc && imgEl.style.display !== 'none'));

            if ((!st || st.type !== 'image') && domHasImage) {
                st = { type: 'image', rawFile: domFile, imageData: domSrc, filename: domFile ? domFile.name : '' };
            }

            if (!st || !st.type) return;

            if (st.type === 'text') {
                (st.value || []).forEach(function (line, i) {
                    if (line && String(line).trim()) props[label + ' - Line ' + (i + 1)] = String(line).trim();
                });

            } else if (st.type === 'icon') {
                props[label + ' - Icon'] = st.value || '';

            } else if (st.type === 'image') {
                images.push(imagePayload(label, st, fileInput, imgEl));
            }

            var emb = st.embellishment;
            if (emb && (emb.checked || emb.enabled)) {
                var name = emb.iconName || emb.icon;
                if (name) props[label + ' - Embellishment Icon'] = name;
                if (emb.position) props[label + ' - Embellishment Position'] = emb.position;
            }

            if (st.type === 'text' && st.fontName) {
                if (fontMode === 'unified' && !fontAdded) {
                    props['Font Style'] = uniqueFonts[0];
                    fontAdded = true;
                } else if (fontMode === 'perLabel') {
                    props[label + ' - Font Style'] = st.fontName;
                }
            }
        });

        return { props: props, images: images };
    }

    function quickValidate(root) {
        var sides = quickSides(root);
        window.ENGRAVING_SIDES = sides;

        for (var i = 0; i < sides.length; i++) {
            var slug = sides[i].slug;
            if (!root.querySelector('.quick_personalize_tab-panel[data-side="' + slug + '"]')) continue;
            if (typeof window.bybValidateSide === 'function') {
                if (!window.bybValidateSide(root, slug, { required: sides.length === 1 })) {
                    if (typeof window.hideReview === 'function') window.hideReview();
                    if (typeof window.switchMainTab === 'function') window.switchMainTab(slug);
                    return false;
                }
            }
        }

        if (typeof window.bybValidateReviewTerms === 'function') {
            if (!window.bybValidateReviewTerms(root)) return false;
        }
        return true;
    }

    /* ══════════════════════════════════════════════════════════════
       ADVANCE DRAWER
       ══════════════════════════════════════════════════════════════ */

    function advInstance(root) {
        if (!window.AdvancePersonalise) return null;
        window.AdvancePersonalise.init(root);
        return window.AdvancePersonalise.get(root);
    }

    function advPrefixes(inst, side, position) {
        var label = inst.sideLabel(side);
        return [
            label + ' ' + cap(position),
            side + ' ' + position,
            side + '-' + position,
            side + ' ' + cap(position)
        ];
    }

    function advIconImage(inst, side, position, iconName) {
        var pool = (window.ICONS_BY_SIDE && window.ICONS_BY_SIDE[side + '__' + position]) || [];
        for (var i = 0; i < pool.length; i++) {
            if (normKey(pool[i].name) === normKey(iconName)) {
                var m = /src="([^"]+)"/.exec(pool[i].svg || '');
                if (m) return m[1];
            }
        }
        var items = inst.$$('.icon-item[data-side="' + side + '"][data-position="' + position + '"]');
        for (var j = 0; j < items.length; j++) {
            if (normKey(items[j].getAttribute('data-icon-name')) === normKey(iconName)) {
                var im = items[j].querySelector('img');
                if (im) return im.getAttribute('src');
            }
        }
        return '';
    }

    function advApplyEntry(inst, side, position, entry, sharedFont) {
        var st = inst.get(side, position);
        if (!st || !entry || !entry.type) return false;

        var wrote = false;

        if (entry.type === 'text') {
            var lines = (entry.value || []).filter(function (v) { return v !== '' && v != null; });
            if (!lines.length && !entry.embIcon) return false;

            inst.switchMode(side, position, 'text');

            var inputs = inst.$$('.field-input[data-side="' + side + '"][data-position="' + position + '"]');
            inputs.forEach(function (input, i) {
                var val = entry.value[i] == null ? '' : String(entry.value[i]);
                input.value = val;
                var row = input.closest('.field-row');
                var counter = row ? row.querySelector('.char-count') : null;
                if (counter) counter.textContent = val.length + '/' + (input.getAttribute('maxlength') || '');
            });

            var font = entry.font || sharedFont || null;
            var fontSel = inst.$('.font-select[data-side="' + side + '"][data-position="' + position + '"]');
            if (fontSel && font) {
                var match = toArray(fontSel.options).filter(function (o) {
                    return normKey(o.value) === normKey(font);
                })[0];
                if (match) {
                    fontSel.value = match.value;
                    inst.selectedFonts[side] = inst.selectedFonts[side] || {};
                    inst.selectedFonts[side][position] = match.value;
                    font = match.value;
                }
            }

            st.type = 'text';
            st.value = inputs.map(function (i) { return i.value.trim(); });
            st.fontName = font || null;
            st.font = font || 'inherit';
            st.imageData = null;
            st.iconIndex = null;

            inst.updatePreview(side, position);
            wrote = true;

        } else if (entry.type === 'icon') {
            inst.switchMode(side, position, 'icon');

            var items = inst.$$('.icon-item[data-side="' + side + '"][data-position="' + position + '"]');
            var found = null;
            items.forEach(function (item) {
                var isMatch = normKey(item.getAttribute('data-icon-name')) === normKey(entry.value);
                item.classList.toggle('selected', isMatch);
                if (isMatch) found = item;
            });

            st.type = 'icon';
            st.value = found ? found.getAttribute('data-icon-name') : entry.value;
            st.iconIndex = found ? parseInt(found.getAttribute('data-icon-index'), 10) : null;
            st.imageData = null;
            st.font = null;

            inst.updateEmbellishmentIconLabel(side, position);
            wrote = true;

        } else if (entry.type === 'image') {
            inst.switchMode(side, position, 'image');

            var img = inst.id(side + '-' + position + '-img-preview');
            var nameEl = inst.id(side + '-' + position + '-img-name');
            var zone = inst.id('upload-zone-' + side + '-' + position);

            if (img) { img.src = entry.imageData; img.style.display = 'block'; }
            if (nameEl) { nameEl.textContent = entry.filename || ''; nameEl.style.display = 'block'; }
            if (zone) {
                zone.classList.add('has-file');
                var ut = zone.querySelector('.upload-text');
                var ui = zone.querySelector('.upload-icon');
                if (ut) ut.style.display = 'none';
                if (ui) ui.style.display = 'none';
            }

            st.type = 'image';
            st.imageData = entry.imageData;
            st.filename = entry.filename || '';
            st.value = null;
            st.font = null;
            st.iconIndex = null;
            st.rawFile = null;
            st.restoredFromUrl = isUrl(entry.imageData);

            wrote = true;
        }

        if (entry.embIcon) {
            st.embellishment = {
                checked: true,
                enabled: true,
                iconName: entry.embIcon,
                iconImg: advIconImage(inst, side, position, entry.embIcon),
                position: entry.embPos || ''
            };
            wrote = true;
        }

        if (wrote) {
            inst.markTouched(side, position);
            ['text', 'image'].forEach(function (m) {
                var box = inst.id('terms-check-' + side + '-' + position + '-' + m);
                if (box) box.checked = true;
            });
            inst.clearPositionErrors(side, position);
            inst.updateSplitPreview(side, position);
        }

        return wrote;
    }

    function advLoad(root, item, options) {
        var opts = options || {};
        var inst = advInstance(root);
        if (!inst) return false;

        var flat = flattenProps(item);
        var props = indexProps(flat);
        var origMap = originalPrefixMap(flat);
        if (!Object.keys(props).length) return false;

        var sharedFont = props['font style'] || null;

        /* Remember the exact property name each position came in under, so
           Update writes "Engraving  Top - Line 1" back verbatim instead of
           minting a differently spaced key. */
        function stampPrefix(side, pos, entry) {
            var sec = inst.section(side, pos);
            if (sec) sec.setAttribute('data-prop-prefix', (entry && origMap[entry.prefix]) || '');
        }

        inst.reset();

        var filled = false;
        var firstSide = null;

        var available = collectPrefixes(props);
        var used = {};
        var misses = [];

        /* Pass 1 — the prefix each side+position derives from its own label. */
        inst.sides.forEach(function (s) {
            var side = s.slug;
            inst.positionsFor(side).forEach(function (pos) {
                var tried = advPrefixes(inst, side, pos);
                var entry = readEntry(props, tried);
                if (!entry) {
                    misses.push({ side: side, pos: pos });
                    return;
                }
                tried.forEach(function (t) { used[normKey(t)] = true; });
                if (advApplyEntry(inst, side, pos, entry, sharedFont)) {
                    stampPrefix(side, pos, entry);
                    filled = true;
                    if (!firstSide) firstSide = side;
                }
            });
        });

        /* Pass 2 — an unclaimed prefix whose last word is this position.
           Covers a side label that changed after the line was added, e.g.
           "Front Engraving  Top" on the line vs "Engraving  Top" now. */
        misses = misses.filter(function (m) {
            var spare = available.filter(function (p) {
                return !used[p] && p.split(' ').pop() === m.pos;
            })[0];
            if (!spare) return true;

            var entry = readEntry(props, [spare]);
            if (!entry) return true;

            used[spare] = true;
            if (advApplyEntry(inst, m.side, m.pos, entry, sharedFont)) {
                stampPrefix(m.side, m.pos, entry);
                filled = true;
                if (!firstSide) firstSide = m.side;
            }
            console.warn('[cart-personalise-edit] ' + m.side + '/' + m.pos +
                ' matched property prefix "' + spare +
                '" by position — the side label appears to have changed.');
            return false;
        });

        /* Pass 3 — legacy line saved before positions existed. Skipped when
           another drawer on this key already matched the line exactly, since
           this fallback would otherwise pull a quick-format line into the
           advance drawer's first position. */
        if (opts.allowLegacy !== false) {
            inst.sides.forEach(function (s) {
                var side = s.slug;
                var positions = inst.positionsFor(side);
                if (!positions.length) return;

                var anyFilledForSide = positions.some(function (pos) {
                    var st = inst.get(side, pos);
                    return st && st.type;
                });
                if (anyFilledForSide) return;

                var legacy = readEntry(props, [inst.sideLabel(side), side]);
                if (legacy && advApplyEntry(inst, side, positions[0], legacy, sharedFont)) {
                    stampPrefix(side, positions[0], legacy);
                    filled = true;
                    if (!firstSide) firstSide = side;
                }
            });
        }

        if (!filled && available.length) {
            console.warn('[cart-personalise-edit] no side/position matched. Drawer expects: ' +
                inst.sides.map(function (s) {
                    return inst.positionsFor(s.slug).map(function (p) {
                        return '"' + inst.positionLabel(s.slug, p) + '"';
                    }).join(', ');
                }).join(' | ') +
                ' — prefixes on this cart line: ' + available.join(', '));
        }

        var allBox = inst.id('terms-check--all');
        if (allBox) allBox.checked = true;

        inst.updateStateBar();
        inst.refreshAllSplitPreviews();
        inst.syncAllReviewBtns();

        if (filled) inst.showReview(firstSide || inst.lastEditedSide);
        return filled;
    }

    function advCollect(root) {
    var inst = advInstance(root);
    if (!inst) return { props: {}, images: [] };

    var props = {};
    var images = [];
    var fontsByLabel = {};
    var fontAdded = false;

    /* Pre-pass sirf font mode decide karne ke liye */
    inst.sides.forEach(function (s) {
        inst.positionsFor(s.slug).forEach(function (pos) {
            var st = inst.get(s.slug, pos);
            if (!st || !st.type) return;
            var sec = inst.section(s.slug, pos);
            var label = (sec && sec.getAttribute('data-prop-prefix')) || inst.positionLabel(s.slug, pos);
            if (st.type === 'text' && st.fontName) {
                fontsByLabel[label] = st.fontName;
            }
        });
    });

    var uniqueFonts = Object.keys(fontsByLabel)
        .map(function (k) { return fontsByLabel[k]; })
        .filter(function (v, i, a) { return a.indexOf(v) === i; });
    var fontMode = uniqueFonts.length === 1 ? 'unified' : (uniqueFonts.length > 1 ? 'perLabel' : 'none');

    inst.sides.forEach(function (s) {
        inst.positionsFor(s.slug).forEach(function (pos) {
            var st = inst.get(s.slug, pos);
            if (!st || !st.type) return;

            var sec = inst.section(s.slug, pos);
            var label = (sec && sec.getAttribute('data-prop-prefix')) ||
                inst.positionLabel(s.slug, pos);

            if (st.type === 'text') {
                (st.value || []).filter(Boolean).forEach(function (line, i) {
                    props[label + ' - Line ' + (i + 1)] = line;
                });

            } else if (st.type === 'icon') {
                props[label + ' - Icon'] = st.value || '';

            } else if (st.type === 'image') {
                var zone = inst.id('upload-zone-' + s.slug + '-' + pos);
                var advFileInput = zone ? zone.querySelector('input[type=file]') : null;
                var advImgEl = inst.id(s.slug + '-' + pos + '-img-preview');
                images.push(imagePayload(label, st, advFileInput, advImgEl));
            }

            var emb = st.embellishment;
            if (emb && (emb.checked || emb.enabled)) {
                var name = emb.iconName || emb.icon;
                if (name) props[label + ' - Embellishment Icon'] = name;
                if (emb.position) props[label + ' - Embellishment Position'] = emb.position;
            }

            /* Font Style ab isi position ke block ke turant baad */
            if (st.type === 'text' && st.fontName) {
                if (fontMode === 'unified' && !fontAdded) {
                    props['Font Style'] = uniqueFonts[0];
                    fontAdded = true;
                            } else if (fontMode === 'perLabel') {
                                props[label + ' - Font Style'] = st.fontName;
                            }
                        }
                    });
                });

                return { props: props, images: images };
            }

    function advValidate(root) {
        var inst = advInstance(root);
        if (!inst) return false;

        var validation = inst.validateAllSides(true);
        if (!validation.touched) {
            showDrawerError(root, (window.PERSONALISE_MESSAGES || {}).empty || 'Please add your personalisation.');
            return false;
        }
        if (!validation.ok) {
            showDrawerError(root, validation.errors[0]);
            inst.focusInvalidPosition(validation.firstSide, validation.firstPosition, validation.errorId);
            return false;
        }
        if (!inst.validateGlobalTerms(true)) {
            showDrawerError(root, (window.PERSONALISE_MESSAGES || {}).terms || 'Please accept the terms.');
            return false;
        }
        return inst.captureAll();
    }

    /* ══════════════════════════════════════════════════════════════
       EDIT LINK  →  open + prefill
       ══════════════════════════════════════════════════════════════ */

    /* Capture on window so this runs before the document-level handler in
       cart-items.js and can take over for the drawers we own. */
    /* How many of this drawer's own prefixes appear verbatim on the line.
       A product with both metafields renders both drawer types on the same
       key, so "first candidate that loads something" is not good enough —
       the advance legacy fallback happily swallows a quick-format line and
       drops it all into the first position. Score both, take the better. */
    function quickScore(root, props) {
        var hits = 0;
        quickSides(root).forEach(function (s) {
            if (readEntry(props, [deriveLabel(s.slug), s.slug])) hits++;
        });
        return hits;
    }

    function advScore(root, props) {
        var inst = advInstance(root);
        if (!inst) return 0;
        var hits = 0;
        inst.sides.forEach(function (s) {
            inst.positionsFor(s.slug).forEach(function (pos) {
                if (readEntry(props, advPrefixes(inst, s.slug, pos))) hits++;
            });
        });
        return hits;
    }

    function scoreCandidate(c, props) {
        if (c.kind === 'advance') return advScore(c.root, props);
        if (c.kind === 'backcard') return backcardScore(c.root, props);
        return quickScore(c.root, props);
    }

    /* Wipe a drawer so a line that matched nothing can never show the
       previously edited line's values. */
       function clearDrawer(c) {
                if (c.kind === 'advance') {
                    var inst = advInstance(c.root);
                    if (inst) inst.reset();
                    return;
                }
                if (c.kind === 'backcard') {
                    resetBackcardDrawer(c.root);  
                    return;
                }
                var sides = quickSides(c.root);
                window.ENGRAVING_SIDES = sides;
                if (typeof window.resetDrawerState === 'function') window.resetDrawerState(c.root);
                window.ENGRAVING_SIDES = sides;
            }

            function clearEverything() {
                toArray(document.querySelectorAll(ADV_SEL)).forEach(function (root) {
                    var inst = advInstance(root);
                    if (inst) inst.reset();
                });

                if (window._personaliseState) {
                    Object.keys(window._personaliseState).forEach(function (k) {
                        delete window._personaliseState[k];
                    });
                }
                window.lastEditedSide = null;

                toArray(document.querySelectorAll(QUICK_SEL)).forEach(function (root) {
                    clearDrawer({ kind: 'quick', root: root });
                });

                toArray(document.querySelectorAll(BACKCARD_SEL)).forEach(function (root) {   // ← add this
                    clearDrawer({ kind: 'backcard', root: root });
                });
            }
    // function clearDrawer(c) {
    //     if (c.kind === 'advance') {
    //         var inst = advInstance(c.root);
    //         if (inst) inst.reset();
    //         return;
    //     }
    //     if (c.kind === 'backcard') {
    //         toArray(c.root.querySelectorAll('input[type="checkbox"]')).forEach(function (cb) {
    //             cb.checked = false;
    //         });
    //         return;
    //     }
    //     var sides = quickSides(c.root);
    //     window.ENGRAVING_SIDES = sides;
    //     if (typeof window.resetDrawerState === 'function') window.resetDrawerState(c.root);
    //     window.ENGRAVING_SIDES = sides;
    // }

    /* Every quick drawer on the page shares one window._personaliseState,
       keyed by side slug alone. Two products whose sides both handleize to
       "engraving" therefore write to the same entry, and handleEdit() will
       happily repopulate one product's inputs from the other's leftovers.
       Only one line is ever edited at a time, so the safe move is to reset
       everything on the page before loading the line that was clicked. */
    function clearEverything() {
        toArray(document.querySelectorAll(ADV_SEL)).forEach(function (root) {
            var inst = advInstance(root);
            if (inst) inst.reset();
        });

        /* Drop every key first, then let each quick drawer's own reset
           re-seed empty entries for its own sides — deleting without
           re-seeding would stop the shopper typing into an empty drawer. */
        if (window._personaliseState) {
            Object.keys(window._personaliseState).forEach(function (k) {
                delete window._personaliseState[k];
            });
        }
        window.lastEditedSide = null;

        toArray(document.querySelectorAll(QUICK_SEL)).forEach(function (root) {
            clearDrawer({ kind: 'quick', root: root });
        });
    }

    window.addEventListener('click', function (e) {
        var link = e.target.closest('.byb-cart-edit-link');
        if (!link) return;

        var lineKey = link.getAttribute('data-line-key');
        var candidates = resolveDrawers(lineKey);
        if (!candidates.length) return;      // backing card etc → old handler

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        candidates.forEach(function (c) {
            c.root.setAttribute('data-key', lineKey);
            if (link.dataset.productId) c.root.setAttribute('data-product-id', link.dataset.productId);
            if (link.dataset.variantId) c.root.setAttribute('data-variant-id', link.dataset.variantId);
        });

        window._bybCartEditLineKey = lineKey;
        window._bybCartEditVariantId = link.dataset.variantId || null;
        window._bybCartEditProductId = link.dataset.productId || null;

        fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var item = (cart.items || []).filter(function (it) {
                    return String(it.key) === String(lineKey);
                })[0];

                if (!item) {
                    console.warn('[cart-personalise-edit] cart line not found:', lineKey);
                    return;
                }

                var props = indexProps(flattenProps(item));

                /* Reset the whole page, not just this key's candidates —
                   the shared quick state is keyed by side slug only. */
                clearEverything();

                /* Rank by exact prefix matches; only fall back to the fuzzy
                   matching inside advLoad/quickLoad if nothing scores. */
                var ranked = candidates.map(function (c) {
                    return { c: c, score: scoreCandidate(c, props) };
                }).sort(function (a, b) {
                    if (b.score !== a.score) return b.score - a.score;
                    return a.c.kind === 'advance' ? -1 : 1;
                });

                var order = ranked.map(function (r) { return r.c; });
                var anyExact = ranked[0] && ranked[0].score > 0;
                var winner = null;

                for (var i = 0; i < order.length; i++) {
                    var c = order[i];
                    openDrawer(c.root);
                    c.root._bybCartItem = item;

                    var ok = c.kind === 'advance'
                        ? advLoad(c.root, item, { allowLegacy: !anyExact })
                        : quickLoad(c.root, item);

                    if (ok) { winner = c; break; }
                    closeDrawer(c.root);
                }

                if (window.CART_PERSONALISE_DEBUG) {
                    console.log('[cart-personalise-edit] line', lineKey,
                        '| scores', ranked.map(function (r) { return r.c.kind + '=' + r.score; }).join(' '),
                        '| winner', winner ? winner.kind : 'none',
                        '| product', winner ? winner.root.getAttribute('data-product-id') : '-',
                        '| quick state', window._personaliseState);
                }

                if (winner) return;

                /* Nothing matched anywhere. Open the preferred drawer EMPTY —
                   it was cleared above, so no stale values — and say exactly
                   what was on the line so the mismatch is not a mystery. */
                openDrawer(candidates[0].root);
                candidates[0].root._bybCartItem = item;

                console.warn(
                    '[cart-personalise-edit] no personalisation properties matched on line ' + lineKey +
                    '. Drawers tried: ' + candidates.map(function (c) { return c.kind; }).join(', ') +
                    '. Properties on this line:',
                    flattenProps(item)
                );
            })
            .catch(function (err) {
                console.error('[cart-personalise-edit] could not read cart:', err);
            });
    }, true);

    /* Clear the edit flag whenever one of our drawers is dismissed. */
    window.addEventListener('click', function (e) {
        var closer = e.target.closest('.drawer-close, .overlay');
        if (!closer) return;

        var pop = closer.closest('.pop-up');
        var root = pop ? (pop.querySelector(ADV_SEL) || pop.querySelector(QUICK_SEL)) : null;
        if (!root) return;

        closeDrawer(root);
        window._bybCartEditLineKey = null;
        window._bybCartEditVariantId = null;
        window._bybCartEditProductId = null;
    }, true);

    /* ══════════════════════════════════════════════════════════════
       UPDATE  →  write back to the line
       ══════════════════════════════════════════════════════════════ */

    window.addEventListener('click', function (e) {
     var btn = e.target.closest('.builder-add-shared, [data-id="builder-add-shared"]');
        if (!btn) return;

        /* PEHLE yahan yeh line thi jo backcard ko poori tarah skip kar deti thi:
        if (btn.classList.contains('backing-update')) return;
        — ab hata di, kyunki backcard bhi isi system se update hoga. */

        var root = btn.closest(ADV_SEL) || btn.closest(QUICK_SEL) || btn.closest(BACKCARD_SEL);
        if (!root) return;

        var kind = root.matches(ADV_SEL) ? 'advance' :
            (root.matches(QUICK_SEL) ? 'quick' : 'backcard');

        var lineKey = btn.getAttribute('data-product-line') ||
            root.getAttribute('data-key') ||
            root.getAttribute('data-item-key') ||
            window._bybCartEditLineKey;

        if (!lineKey) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (btn.disabled || btn.classList.contains('loading')) return;

        var valid = kind === 'advance' ? advValidate(root) :
            (kind === 'quick' ? quickValidate(root) : backcardValidate(root));
        if (!valid) return;

        var collected = kind === 'advance' ? advCollect(root) :
            (kind === 'quick' ? quickCollect(root) : backcardCollect(root));
        var engravingProps = collected.props;
        var images = collected.images;

        var newFiles = images.filter(function (i) { return i.file instanceof File; });
        var keptUrls = images.filter(function (i) { return !(i.file instanceof File) && i.url; });

        var lostImages = images.filter(function (i) { return !(i.file instanceof File) && !i.url; });
        if (lostImages.length) {
            console.warn('[cart-personalise-edit] image could not be resolved for:',
                lostImages.map(function (i) { return i.label; }).join(', '));
            showDrawerError(root, 'Please re-upload your image and try again.');
            return;
        }

        if (!Object.keys(engravingProps).length && !images.length) {
            console.warn('[cart-personalise-edit] refusing to update: nothing collected from',
                kind, 'drawer', root.getAttribute('data-product-id'));
            showDrawerError(root, 'Please add your personalisation before updating.');
            return;
        }

        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('loading');
        btn.innerHTML = 'Updating...';

        function done() {
            window._bybCartEditLineKey = null;
            window._bybCartEditVariantId = null;
            window._bybCartEditProductId = null;

            if (kind === 'advance') {
                var inst = advInstance(root);
                if (inst) inst.reset();
            } else if (kind === 'quick' && typeof window.resetDrawerState === 'function') {
                window.resetDrawerState(root);
            } else if (kind === 'backcard') {
                resetBackcardDrawer(root);  
                // toArray(root.querySelectorAll('input[type="checkbox"]')).forEach(function (cb) {
                //     cb.checked = false;
                // });
            }

            closeDrawer(root);

            return refreshCart().then(function () {
                var sideDrawer = document.querySelector('cart-drawer');
                if (sideDrawer) sideDrawer.classList.remove('active', 'animate');
                document.body.classList.remove('overflow-hidden');

                btn.disabled = false;
                btn.classList.remove('loading');
                btn.innerHTML = originalHTML;
            });
        }

        function fail(err) {
            console.error('[cart-personalise-edit] update failed:', err);
            showDrawerError(root, (err && err.message) || 'Something went wrong');
            btn.disabled = false;
            btn.classList.remove('loading');
            btn.innerHTML = originalHTML;
        }

        fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var item = (cart.items || []).filter(function (it) {
                    return String(it.key) === String(lineKey);
                })[0];
                if (!item) throw new Error('Cart line not found');

                var existing = flattenProps(item);

                var owned = ownedKeyPredicate(kind, root);
                var preserved = {};
                Object.keys(existing).forEach(function (k) {
                    if (!owned(k)) preserved[k] = existing[k];
                });

                var merged = Object.assign({}, preserved, engravingProps);
                merged._personalise_product = 'true';

                keptUrls.forEach(function (img) { merged[img.label] = img.url; });

                var qty = item.quantity;
                var variantId = item.variant_id;
                var sellingPlan = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
                    ? item.selling_plan_allocation.selling_plan.id
                    : null;

                if (!newFiles.length) {
                    return fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: lineKey, quantity: qty, properties: merged })
                    }).then(function (res) {
                        return res.json().then(function (data) {
                            if (!res.ok) throw new Error(data.description || data.message || 'Update failed');
                            return data;
                        });
                    });
                }

                return Promise.all(keptUrls.map(function (img) {
                    return urlToFile(img.url, img.filename)
                        .then(function (file) { return { label: img.label, file: file }; })
                        .catch(function () { return null; });
                })).then(function (rehydrated) {

                    var fd = new FormData();
                    fd.append('id', variantId);
                    fd.append('quantity', qty);
                    if (sellingPlan) fd.append('selling_plan', sellingPlan);

                    var fileLabels = {};
                    newFiles.forEach(function (i) { fileLabels[i.label] = true; });
                    rehydrated.forEach(function (i) { if (i) fileLabels[i.label] = true; });

                    Object.keys(merged).forEach(function (k) {
                        if (fileLabels[k]) return;
                        if (merged[k] == null || merged[k] === '') return;
                        fd.append('properties[' + k + ']', merged[k]);
                    });

                    newFiles.forEach(function (i) {
                        fd.append('properties[' + i.label + ']', i.file, i.file.name);
                    });
                    rehydrated.forEach(function (i) {
                        if (i) fd.append('properties[' + i.label + ']', i.file, i.file.name);
                    });

                    var addRequest = new Request('/cart/add.js', { method: 'POST', body: fd });

                    return fetch(addRequest)
                        .then(function (res) {
                            return res.json().then(function (data) {
                                if (!res.ok) throw new Error(data.description || data.message || 'Update failed');
                                return data;
                            });
                        })
                        .then(function (added) {
                            return fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: lineKey, quantity: 0 })
                            }).then(function () { return added; });
                        });
                });
            })
            .then(done)
            .catch(fail);
    }, true);

    /* ══════════════════════════════════════════════════════════════
       PUBLIC HELPERS
       ══════════════════════════════════════════════════════════════ */

    window.CartPersonaliseEdit = {
        resolveDrawer: resolveDrawer,
        openLine: function (lineKey) {
            var target = resolveDrawer(lineKey);
            if (!target) return Promise.resolve(false);
            openDrawer(target.root);
            return fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                    var item = (cart.items || []).filter(function (it) {
                        return String(it.key) === String(lineKey);
                    })[0];
                    if (!item) return false;
                    return target.kind === 'advance'
                        ? advLoad(target.root, item)
                        : quickLoad(target.root, item);
                });
        },
        collect: function (root) {
            return root.matches(ADV_SEL) ? advCollect(root) : quickCollect(root);
        },

        debug: function (lineKey) {
            var target = resolveDrawer(lineKey);
            if (!target) {
                console.log('No quick or advance drawer found for line key:', lineKey);
                return;
            }

            return fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                    var item = (cart.items || []).filter(function (it) {
                        return String(it.key) === String(lineKey);
                    })[0];
                    if (!item) { console.log('Cart line not found:', lineKey); return; }

                    var flat = flattenProps(item);
                    var props = indexProps(flat);
                    var expected = [];

                    if (target.kind === 'advance') {
                        var inst = advInstance(target.root);
                        inst.sides.forEach(function (s) {
                            inst.positionsFor(s.slug).forEach(function (p) {
                                expected.push(inst.positionLabel(s.slug, p));
                            });
                        });
                    } else {
                        quickSides(target.root).forEach(function (s) {
                            expected.push(deriveLabel(s.slug));
                        });
                    }

                    console.log('drawer kind :', target.kind);
                    console.log('expects     :', expected);
                    console.log('line has    :', collectPrefixes(props));
                    console.log('all props   :', flat);
                    return { expected: expected, found: collectPrefixes(props), properties: flat };
                });
        }
    };
})();

//BACKCARD

function toArray(l) { return Array.prototype.slice.call(l || []); }

function normKey(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase();
}

function flattenProps(item) {
    var out = {};
    var src = item && item.properties;
    if (!src) return out;

    if (Array.isArray(src)) {
        src.forEach(function (p) {
            if (!p) return;
            var k = p.name || p.key;
            if (k) out[k] = p.value;
        });
        return out;
    }
    if (typeof src === 'object') return Object.assign({}, src);
    return out;
}

function isEngravingKey(key) {
    if (!key) return false;
    if (key.charAt(0) === '_') return false;
    var ENGRAVING_KEY = / - (line \d+|icon|image|font style|embellishment (icon|position))$/i;
    if (/^font style$/i.test(key.trim())) return true;
    return ENGRAVING_KEY.test(key);
}

function showDrawerError(drawer, msg) {
    var el = drawer.querySelector('.quick_personalize_personalized-error') ||
        drawer.querySelector('.personalized-error');
    if (!el) return;
    clearTimeout(el._hideTimer);
    el.classList.remove('hidden');
    el.classList.add('active');
    el.style.color = 'red';
    el.textContent = msg;
    el._hideTimer = setTimeout(function () {
        el.classList.remove('active');
        el.classList.add('hidden');
    }, 3500);
}
function backcardOptions(root) {
    var seen = {};
    var out = [];
    toArray(root.querySelectorAll('.backcard_main-tab[data-side]')).forEach(function (tab) {
        var slug = tab.getAttribute('data-side');
        if (!slug || seen[slug]) return;
        seen[slug] = true;
        var label = (tab.textContent || slug).replace(/\s+/g, ' ').trim();
        out.push({ slug: slug, label: label });
    });
    return out;
}

function backcardScore(root, props) {
    var hits = 0;
    backcardOptions(root).forEach(function (opt) {
        if (props[normKey(opt.label)] !== undefined) hits++;
    });
    return hits;
}
function backcardLoad(root, item) {
    var flat = flattenProps(item);
    var options = backcardOptions(root);
    if (!options.length) return false;

    var filled = false;
    var firstSide = null;
    options.forEach(function (opt) {
    var panel = root.querySelector('.backcard_tab-panel[data-side="' + opt.slug + '"]');
    if (!panel) return;

    var propValue = flat[opt.label];
            if (propValue === undefined) return;

            var checkboxes = toArray(panel.querySelectorAll('input[type="checkbox"]'));
            var matched = null;
            checkboxes.forEach(function (cb) {
                var isMatch = normKey(cb.value) === normKey(propValue);
                cb.checked = isMatch;
                if (isMatch) matched = cb;
            });

            if (matched) {
                filled = true;
                if (!firstSide) firstSide = opt.slug;
                matched.dispatchEvent(new Event('change', { bubbles: true }));
                var tabBtn = root.querySelector('.backcard_main-tab[data-side="' + opt.slug + '"]');
                
                if (tabBtn) tabBtn.classList.add('has-selection');   
            }
        });

    var termsCb = root.querySelector('.backcard_terms-checkbox input[type="checkbox"]');
    if (termsCb) termsCb.checked = true;

    if (filled && firstSide && typeof window.switchBackcardTab === 'function') {
        window.switchBackcardTab(root, firstSide);
    }

    return filled;
}


function backcardCollect(root) {
    var options = backcardOptions(root);
    var props = {};
    options.forEach(function (opt) {
        var panel = root.querySelector('.backcard_tab-panel[data-side="' + opt.slug + '"]');
        if (!panel) return;
        var checked = panel.querySelector('input[type="checkbox"]:checked');
        if (checked) props[opt.label] = checked.value;
    });
    return { props: props, images: [] };
}
function backcardTermsError(root) {
    var cb = root.querySelector('.backcard_terms-checkbox input[type="checkbox"]');
    if (!cb) return null;
    var wrap = cb.closest('.backcard_terms-wrapper');
    if (!wrap) return null;
    var err = wrap.querySelector('.backcard_checkbox-error');
    if (!err) {
        err = document.createElement('div');
        err.className = 'backcard_checkbox-error field-error';
        wrap.appendChild(err);
    }
    return err;
}

function backcardValidate(root) {
    var termsCb = root.querySelector('.backcard_terms-checkbox input[type="checkbox"]');
    if (!termsCb) return true;          // no checkbox rendered → nothing to enforce
    if (termsCb.checked) return true;

    var err = backcardTermsError(root);
    if (err) {
        err.textContent = 'Please agree to the Terms & Conditions.';
        err.classList.remove('hidden');
    }
    termsCb.classList.add('is-invalid');

    var wrap = termsCb.closest('.backcard_terms-wrapper');
    if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });

    return false;
}

function ownedKeyPredicate(kind, root) {
    if (kind === 'backcard') {
        var labels = backcardOptions(root).map(function (o) { return normKey(o.label); });
        return function (key) {
            if (!key || key.charAt(0) === '_') return false;
            return labels.indexOf(normKey(key)) !== -1;
        };
    }
    return isEngravingKey;
}
function resetBackcardDrawer(root) {
    toArray(root.querySelectorAll('input[type="checkbox"]')).forEach(function (cb) {
        cb.checked = false;
    });
    toArray(root.querySelectorAll('.backcard_main-tab')).forEach(function (tab) {
        tab.classList.remove('has-selection');
    });
    var firstTab = root.querySelector('.backcard_main-tab');
    if (firstTab && typeof window.switchBackcardTab === 'function') {
        window.switchBackcardTab(root, firstTab.getAttribute('data-side'));
    }
}